import Div from 'src/components/atomic/atom/Div'
import Span from 'src/components/atomic/atom/Span'
import { COLOR } from 'src/constants/colors'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { RootState } from 'src/store/store'
import { LocationDataPropsType } from 'src/views/Service/Location'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'

const LocationPlaySoundList = (props: { data: LocationDataPropsType }) => {
  const { setMediaStyle } = useMediaQueryHook()
  const { playSoundList, onSoundListItemClick, OptionRef } = props.data
  const { soundListFlag } = useAppSelector((state: RootState) => state.LocationPage)

  return (
    <Div
      ref={OptionRef}
      // display={soundListFlag ? 'block' : 'none'}
      width={setMediaStyle('194px', '100%', '100%')}
      $position={'absolute'}
      $bgColor={'white'}
      $border_radius={'12px'}
      $border={soundListFlag ? `1px solid ${COLOR.brand}` : 'unset'}
      $padding={soundListFlag ? '46px 0 11px 0' : ''}
      $max_height={soundListFlag ? 'unset' : '0'}
      style={{ right: 0, top: '2px', zIndex: 1, transition: 'all 0.2s' }}
    >
      {soundListFlag &&
        playSoundList.map((element, index) => (
          <Div
            key={element}
            width={setMediaStyle('160px', '', '')}
            $margin={'0 13px'}
            $padding={'8px 0'}
            style={{ borderBottom: `1px solid ${COLOR.black10}` }}
            className={`notice_call_${index + 1}`}
          >
            <Span
              option={'small'}
              $text_align={'left'}
              color={COLOR.black50}
              onClick={onSoundListItemClick}
            >
              {element}
            </Span>
          </Div>
        ))}
    </Div>
  )
}
export default LocationPlaySoundList
